
import { defineComponent } from 'vue';
import {
  AjaxHelper,
  MatomoUrl, translate,
} from 'CoreHome';
import { Field } from 'CorePluginsAdmin';

export default defineComponent({
  props: {
    metrics: {
      type: Object,
      required: true,
    },
    limits: {
      type: Object,
      required: true,
    },
    selectedMetric: {
      type: String,
      required: true,
    },
    selectedLimit: {
      type: Number,
      required: false,
      default: 10,
    },
    period: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      metric: this.selectedMetric,
      limit: this.selectedLimit,
    };
  },
  components: {
    Field,
  },
  methods: {
    updateSelection() {
      MatomoUrl.updateHash({
        ...MatomoUrl.hashParsed.value,
        metric: this.metric,
        filter_limit: this.limit,
      });

      this.saveParameters();

      window.location.reload();
    },
    saveParameters() {
      AjaxHelper.post(
        {
          module: 'CoreHome',
          action: 'saveViewDataTableParameters',
          report_id: 'Cohorts.getCohortsTable',
          segment: '',
        },
        {
          parameters: JSON.stringify({
            metric: this.metric,
            filter_limit: this.limit,
          }),
        },
        {
          withTokenInUrl: true,
          format: 'html',
        },
      ).catch(() => {
        // ignore
      });
    },
    getCohortsSizeTitle() {
      let string1 = translate('Intl_PeriodDay');
      let string2 = translate('General_DailyReport');
      if (this.period === 'week') {
        string1 = translate('Intl_PeriodWeek');
        string2 = translate('General_WeeklyReport');
      } else if (this.period === 'month') {
        string1 = translate('Intl_PeriodMonth');
        string2 = translate('General_MonthlyReport');
      } else if (this.period === 'year') {
        string1 = translate('Intl_PeriodYear');
        string2 = translate('General_YearlyReport');
      }
      const title = translate(
        'Cohorts_CohortsNumberHelpText',
        string1,
        string2,
        '<br><br>',
      );
      return translate(
        'Cohorts_CohortsNumber',
        `<span class="icon-help" title="${title}"></span>`,
      );
    },
  },
});
